module.exports = __webpack_public_path__ + "img/credit-icon.6803273f.png";